import { render, staticRenderFns } from "./Creator.vue?vue&type=template&id=0989ad42&scoped=true"
import script from "./Creator.vue?vue&type=script&lang=js"
export * from "./Creator.vue?vue&type=script&lang=js"
import style0 from "./Creator.vue?vue&type=style&index=0&id=0989ad42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0989ad42",
  null
  
)

export default component.exports